import { CompTableColumnId, CompTableColumns, isDefined } from '@aloft/toolkit-shared';

export const COMP_TABLE_COLUMN_ID_TO_TANSTACK_ID: Record<CompTableColumnId, string> = {
  address: 'Address',
  similarity: 'Similarity Score',
  proximity: 'Proximity',
  salePrice: 'Sale Price',
  saleDate: 'Sale Date',
  gla: 'GLA',
  qualityTier: 'Quality Tier',
  quality: 'Qlty.',
  condition: 'Cond.',
  yearBuilt: 'Year Built',
  siteSize: 'Lot Size',
  cdom: 'CDOM',
  beds: 'Beds',
  fullBaths: 'Full Baths',
  halfBaths: 'Half Baths',
  garage: 'Garage Count',
  basement: 'Basement',
  pool: 'Pool',
  mlsId: 'MLS ID',
  propertyType: 'Property Type',
  contractDate: 'Contract Date',
  listPrice: 'List Price',
  sqftPrice: 'Sqft Price',
  garageCount: 'Garage Count',
  status: 'Status',
};

export const PINNED_COMP_TABLE_TANSTACK_IDS = ['select', 'Address', 'Similarity Score'] as const;

const FIXED_LEADING_TANSTACK_IDS: readonly string[] = PINNED_COMP_TABLE_TANSTACK_IDS;

const TANSTACK_ID_TO_COMP_TABLE_COLUMN_ID: Partial<Record<string, CompTableColumnId>> = {};
for (const [id, tanstackId] of Object.entries(COMP_TABLE_COLUMN_ID_TO_TANSTACK_ID)) {
  if (!(tanstackId in TANSTACK_ID_TO_COMP_TABLE_COLUMN_ID)) {
    TANSTACK_ID_TO_COMP_TABLE_COLUMN_ID[tanstackId] = id as CompTableColumnId;
  }
}

const FIXED_LEADING_COMP_TABLE_IDS = PINNED_COMP_TABLE_TANSTACK_IDS.map(
  (id) => TANSTACK_ID_TO_COMP_TABLE_COLUMN_ID[id],
).filter(isDefined);

export const compTableColumnsToTableState = (
  columns: CompTableColumns,
): { columnOrder: string[]; columnVisibility: Record<string, boolean> } => {
  const orderedTanstackIds = columns.order
    .map((id) => COMP_TABLE_COLUMN_ID_TO_TANSTACK_ID[id])
    .filter((tanstackId) => !FIXED_LEADING_TANSTACK_IDS.includes(tanstackId));

  const columnOrder = [...FIXED_LEADING_TANSTACK_IDS, ...orderedTanstackIds];

  const columnVisibility = Object.fromEntries(
    columns.hidden.map((id) => [COMP_TABLE_COLUMN_ID_TO_TANSTACK_ID[id], false]),
  );

  return { columnOrder, columnVisibility };
};

export const tableStateToCompTableColumns = (
  columnOrder: string[],
  previous: CompTableColumns,
): CompTableColumns => {
  const fromTable = columnOrder
    .filter((id) => !FIXED_LEADING_TANSTACK_IDS.includes(id))
    .map((id) => TANSTACK_ID_TO_COMP_TABLE_COLUMN_ID[id])
    .filter(isDefined)
    .filter((id) => !FIXED_LEADING_COMP_TABLE_IDS.includes(id));

  const fromTableSet = new Set(fromTable);
  const remaining = previous.order.filter(
    (id) => !FIXED_LEADING_COMP_TABLE_IDS.includes(id) && !fromTableSet.has(id),
  );

  return {
    order: [...FIXED_LEADING_COMP_TABLE_IDS, ...fromTable, ...remaining],
    hidden: previous.hidden,
  };
};
